import { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface CancelPlanModalProps {
    show: boolean;
    onHide: () => void;
    onConfirmCancel: (reason: string) => void;
}

export default function UserPlanCancellationModal({
    show,
    onHide,
    onConfirmCancel,
}: CancelPlanModalProps) {
    const [reason, setReason] = useState('');
    const isValid = reason.trim().length >= 3;
    const inputRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (show) {
            const id = setTimeout(() => inputRef.current?.focus(), 0);
            return () => clearTimeout(id);
        }
    }, [show]);

    function handleHide() {
        setReason('');
        onHide();
    }

    function handleConfirm() {
        if (!isValid) return;
        onConfirmCancel(reason.trim());
        setReason('');
    }

    return (
        <Modal centered show={show} onHide={handleHide}>
            <Modal.Header closeButton>
                <Modal.Title>Cancel Plan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Are you sure you want to cancel the plan? The parker(s) will have access until the end of the current billing period.
                </p>
                <Form.Group className="mb-3">
                    <Form.Label>Reason for cancellation <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        ref={inputRef}
                        as="textarea"
                        rows={3}
                        placeholder="Enter reason for cancellation..."
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        isInvalid={reason.length > 0 && !isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                        Please enter at least 3 characters.
                    </Form.Control.Feedback>
                </Form.Group>
                <div className="d-flex flex-column gap-3">
                    <Button variant="danger" onClick={handleConfirm} disabled={!isValid}>
                        Confirm Cancellation
                    </Button>
                    <Button variant="outline-secondary" onClick={handleHide}>
                        Go Back
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
